/**
 * @generated SignedSource<<bb5060fabddb86139fb18ac827898dae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotType = "BUCKET" | "MULTI" | "QUEUE" | "SINGLE";
import { FragmentRefs } from "relay-runtime";
export type GroupSizeControlNode$data = {
  readonly __typename: "AvailabilitySlot";
  readonly id: string;
  readonly startSlots: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly capacity: number;
        readonly id: string;
        readonly usedCapacity: number;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "GroupSizeControlNode";
} | {
  readonly __typename: "TimeSlot";
  readonly standardCapacity: number;
  readonly type: SlotType;
  readonly usedCapacity: number;
  readonly " $fragmentType": "GroupSizeControlNode";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "GroupSizeControlNode";
};
export type GroupSizeControlNode$key = {
  readonly " $data"?: GroupSizeControlNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupSizeControlNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedCapacity",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "kind": "Literal",
  "name": "bookingType",
  "value": "LESSON"
},
v3 = {
  "kind": "Variable",
  "name": "lessonTypeId",
  "variableName": "lessonTypeId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "facilityId"
    },
    {
      "kind": "RootArgument",
      "name": "lessonTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupSizeControlNode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": "standardCapacity",
          "args": [
            {
              "kind": "Literal",
              "name": "bookingType",
              "value": "STANDARD"
            }
          ],
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        },
        (v0/*: any*/)
      ],
      "type": "TimeSlot",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "fields": [
                (v2/*: any*/),
                {
                  "kind": "Variable",
                  "name": "facilityId",
                  "variableName": "facilityId"
                },
                (v3/*: any*/)
              ],
              "kind": "ObjectValue",
              "name": "slotAvailability"
            }
          ],
          "concreteType": "TimeSlotConnection",
          "kind": "LinkedField",
          "name": "startSlots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": [
                        (v2/*: any*/),
                        (v3/*: any*/)
                      ],
                      "kind": "ScalarField",
                      "name": "capacity",
                      "storageKey": null
                    },
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AvailabilitySlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "1b738c99a2ed62711c77fcf8942c0147";

export default node;
